<template>
  <div class="px-2">
    <div class="d-flex justify-content-between align-items-center" v-if="replyMessage">
      <div class="reply-msg">
        <span>Répondre à</span>
        <span class="user text-green">
        @{{ replyMessage.sender.full_name }}
      </span>
        <i class="fa fa-close"></i>
      </div>
      <i style="font-size: 12px;line-height: 12px" class="ti-close cursor-pointer" @click="reset"></i>
    </div>
    <textarea class="form-control" v-model="content" placeholder="Votre message..."></textarea>
    <div class="image-list mt-1" v-if="images.length">
      <figure v-for="(image,i) in images" class="teaser teaser-simple">
        <img :src="image.path" :alt="image.name">
        <figcaption>
          <button @click="images.splice(i,1)" class="btn btn-gray btn-square">
            <i class="ti-trash" style="font-size: 20px"></i>
          </button>
        </figcaption>
      </figure>
    </div>
    <div class="audio-container mt-1 d-flex align-items-center" v-if="audio">
      <audio-player class="audio-player mini" :src="audio.url" :record="audio.record"/>
      <div style="width: 50px" class="text-right">
        <button class="btn btn-gray btn-square" @click="audio=null">
          <i class="ti-trash" style="font-size: 20px"></i>
        </button>
      </div>
    </div>
    <div class="actions mt-1 d-flex justify-content-between">
      <div class="left">
        <input ref="fileInput" type="file" accept="image/*" @change="fileChange" class="d-none">
        <button v-if="!hasAudio" @click="$refs.fileInput.click()" class="btn btn-square mr-1 btn-gray">
          <img src="@img/image.svg" alt="">
        </button>
        <button v-if="!hasAudio&&!hasImage" @click="toggleRecord" class="btn btn-square btn-gray">
          <img v-if="!isRecording" src="@img/mic.svg" alt="">
          <span v-else style="width: 20px;height: 20px;background: #555;display: block"></span>
        </button>
        <span class="time" v-if="isRecording">{{ recordedTime }}</span>
      </div>
      <div class="right">
        <button :disabled="loading" class="btn btn-outline-primary p-1" @click="submit">
          Envoyer <i class="fa fa-spin fa-spinner" v-if="loading"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import RecorderMixin from "@/components/Mixins/RecorderMixin";
import axios from "axios";

export default {
  name: "MessageEditor",
  props: {
    'discussionId': {required: true},
    'user': {required: true}
  },
  mixins: [RecorderMixin],
  data() {
    return {
      audio: null,
      images: [],
      content: '',
      replyMessage: null,
      loading: false
    }
  },
  computed: {
    hasImage() {
      return this.images.length > 0
    },
    hasAudio() {
      return this.audio != null
    }
  },
  methods: {
    reply(message) {
      this.replyMessage = message
    },
    fileChange(event) {
      for (let i = 0; i < event.target.files.length; i++) {
        const file = event.target.files[i]
        this.images.push({
          name: file.name,
          path: URL.createObjectURL(file),
          file: file
        })
      }
      event.target.value = ""
    },
    submit() {
      if (!this.content && !this.audio && !this.images.length) return
      const data = new FormData()
      data.append('textContent', this.content)
      if (this.replyMessage) {
        data.append('response_to', this.replyMessage.id)
      }
      if (this.audio && this.audio.record) {
        data.append('audio', this.audio.record.blob)
      }
      let idx = 1
      this.images.forEach(function (img) {
        if (img.file) data.append('image' + idx++, img.file)
      })
      data.append('images_count', idx - 1)
      if (this.loading) return
      this.loading = true
      this.$store.dispatch('chat/sendMessage', {
        id: this.discussionId,
        to: this.user,
        data
      })
        .finally(() => {
          this.loading = false
          this.reset()
          this.$nextTick(() => this.$emit('go_down'))
        })
    },
    reset() {
      this.content = ''
      this.images = []
      this.audio = null
      this.replyMessage = null
    }
  }
}
</script>

<style lang="scss" scoped>
.reply-msg {
  color: #555;
  font-size: 12px;
  @include no-break();
}

.image-list {
  display: flex;
  flex-wrap: wrap;
  @include gap-items-x(2%);

  > * {
    &:nth-child(2n+1) {
      margin-left: 0;
    }

    &:nth-child(2n) {
      margin-right: 0;
    }
  }

  figure {
    margin-bottom: 10px;
    width: 46%;
    height: auto;
    max-height: 100px;
  }
}

</style>
